import BookDirectInterstitial from "@/components/SearchPage/BookDirectInterstitial/BookDirectInterstitial";
import React from "react";
import ReactDOM from "react-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

function mountBookDirectInterstitial() {
  const el = document.getElementById("book-direct-interstitial");
  const propsScript = document.getElementById("book-direct-interstitial-props");

  if (el && !el.dataset.reactMounted && propsScript) {
    try {
      const props = JSON.parse(propsScript.textContent || "{}");
      ReactDOM.render(React.createElement(BookDirectInterstitial, props), el);
      el.dataset.reactMounted = "true";
    } catch (e) {
      console.error("Failed to parse props JSON:", e);
    }
  }
}

document.addEventListener("turbo:render", mountBookDirectInterstitial);
document.addEventListener("DOMContentLoaded", mountBookDirectInterstitial);
mountBookDirectInterstitial();
